import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  it: {
    brand: "RISE your LIFE",
    tagline: "Cresciamo. Un giorno alla volta.",
    hero_title: "Il tuo piano di benessere in 7 giorni.",
    hero_sub: "Il programma di longevità per il welfare aziendale. Registra una settimana di abitudini sulle 6 aree del benessere e ricevi un feedback personalizzato guidato da professionisti del settore e dall'AI.",
    cta_start: "Inizia ora",
    aud_personal: "Per te",
    aud_business: "Per le aziende",
    hero_sub_personal: "Registra per 7 giorni alimentazione, movimento, sonno e abitudini. Ricevi un piano personalizzato, costruito con i professionisti del programma e generato con l'intelligenza artificiale. Gratis.",
    hero_title_biz: "Il benessere dei tuoi dipendenti, un giorno alla volta.",
    hero_sub_biz: "Un programma di welfare aziendale su 6 aree: alimentazione, esercizio fisico, sonno, freddo, respirazione e relazioni. Ogni dipendente riceve un piano personalizzato.",
    cta_free: "Inizia gratis",
    cta_code_link: "Hai un codice aziendale? Registrati qui",
    cta_book_demo: "Prenota una presentazione",
    how_personal_title: "Come funziona",
    how_p1: "Ti registri e definisci il tuo obiettivo",
    how_p2: "Per 7 giorni registri le tue abitudini, anche a voce",
    how_p3: "Ricevi il tuo piano personalizzato",
    faq_title: "Privacy, in breve",
    faq_q1: "L'azienda vede i dati dei singoli dipendenti?",
    faq_a1: "No. L'azienda non riceve mai i dati personali dei dipendenti. Eventuali report per l'azienda conterranno solo dati aggregati e anonimi.",
    faq_q2: "Chi vede i dati individuali?",
    faq_a2: "Solo i professionisti del programma RISE your LIFE incaricati dal titolare del trattamento, MDS – MED SRL, per costruire il piano personalizzato.",
    faq_q3: "RISE your LIFE fa diagnosi?",
    faq_a3: "No. È un programma di benessere: non fornisce diagnosi né terapie e non sostituisce il parere del medico.",
    cta_login: "Accedi",
    how_title: "Come funziona in azienda",
    step1_t: "Incontro & obiettivi",
    step1_d: "Presentiamo i fondamentali della longevità e definisci il tuo obiettivo.",
    step2_t: "1 settimana di dati",
    step2_d: "Registra sonno, movimento, alimentazione, freddo, respiro e relazioni.",
    step3_t: "Feedback AI",
    step3_d: "Ricevi un piano personalizzato basato sui tuoi dati e obiettivi.",
    pillars_title: "Le 6 aree del benessere",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    name: "Nome",
    first_name: "Nome",
    invite_code: "Codice aziendale",
    invite_code_hint: "Se te l'ha dato la tua azienda. Altrimenti lascia vuoto.",
    invite_code_invalid: "Codice non valido. Controlla con la tua azienda o lascia il campo vuoto.",
    invite_code_limit: "Troppi tentativi, riprova più tardi.",
    admin_invite_code: "Codice aziendale",
    admin_below_threshold: "Dati disponibili da {n} partecipanti in su, per proteggere la privacy dei dipendenti.",
    admin_copy: "Copia",
    admin_copied: "Codice copiato",
    admin_regenerate: "Rigenera",
    admin_regenerate_confirm: "Il vecchio codice smetterà di funzionare.",
    ai_disclaimer: "I contenuti di RISE your LIFE hanno finalità di benessere e non sostituiscono il parere del medico: non forniscono diagnosi né terapie.",
    last_name: "Cognome",
    admin_slug_reserved: "Indirizzo riservato, scegline un altro.",
    company: "Azienda",
    no_account: "Non hai un account?",
    have_account: "Hai già un account?",
    logout: "Esci",
    // areas
    nutrition: "Alimentazione",
    exercise: "Esercizio Fisico",
    sleep: "Sonno",
    cold: "Freddo",
    breathing: "Respirazione",
    relationships: "Relazioni",
    pillars: "Fondamentali",
    corollaries: "Corollari",
    // onboarding
    onboard_title: "Definisci il tuo obiettivo",
    onboard_sub: "Il tuo obiettivo guiderà il feedback personalizzato dell'AI.",
    goal_label: "Qual è il tuo obiettivo principale?",
    focus_label: "Su quali aree vuoi concentrarti? (opzionale)",
    save: "Salva e inizia",
    // dashboard
    dashboard: "Dashboard",
    welcome: "Bentornato",
    day_of: "Giorno",
    track_today: "Registra oggi",
    points: "Punti",
    streak: "Giorni di fila",
    badges: "Traguardi",
    days_logged: "Giorni registrati",
    weekly_report: "Report settimanale",
    generate_report: "Genera report AI",
    generating: "Generazione in corso...",
    reports: "I miei report",
    wakeup_card: "Benessere delle relazioni — al risveglio",
    diary: "Diario",
    diary_title: "Diario Longevità",
    diary_sub: "Scrivi in modo naturale cosa mangi e cosa fai. Ci pensa l'AI ad analizzare carico glicemico, nutrienti e recupero.",
    diary_placeholder: "Es. \"Corsa intensa di 40 minuti\" oppure \"Pasta al pesto e un'arancia\"",
    diary_send: "Analizza",
    analyzing: "Analisi in corso...",
    diary_empty: "Il tuo diario è vuoto. Scrivi il tuo primo pasto o allenamento qui sopra.",
    open_diary: "Apri il diario",
    longevity_score: "Punteggio Longevità",
    level: "Livello",
    to_next: "punti al prossimo livello",
    max_level: "Livello massimo raggiunto!",
    glycemic_load: "Carico glicemico",
    nutrients: "Nutrienti",
    vitamins: "Vitamine",
    antioxidants: "Antiossidanti",
    macros: "Macronutrienti",
    advice: "Consiglio",
    recovery_meal: "Recupero post-allenamento",
    injury_prevention: "Prevenzione infortuni",
    points_earned: "punti",
    intensity: "Intensità",
    duration: "Durata",
    calories: "Calorie stimate",
    tl_verde: "Verde",
    tl_giallo: "Giallo",
    tl_rosso: "Rosso",
    onboard_sports: "Quali sport o attività pratichi?",
    sports_placeholder: "Es. corsa, nuoto, palestra, yoga...",
    onboard_frequency: "Con che frequenza ti alleni?",
    freq_none: "Raramente / Mai",
    freq_1_2: "1-2 volte a settimana",
    freq_3_4: "3-4 volte a settimana",
    freq_5plus: "5+ volte a settimana",
    onboard_diet: "Preferenze alimentari",
    diet_completo: "Completa (onnivora)",
    diet_mediterraneo: "Mediterranea",
    diet_vegetariano: "Vegetariana",
    diet_vegano: "Vegana",
    onboard_age: "Età",
    onboard_conditions: "Patologie croniche (opzionale)",
    conditions_placeholder: "Es. diabete, ipertensione, tiroide...",
    onboard_pain: "Dolori o zone da tutelare (opzionale)",
    pain_placeholder: "Es. ginocchio destro, zona lombare...",
    onboard_health_note: "Queste informazioni servono a personalizzare i consigli in sicurezza. RISE your LIFE non fornisce diagnosi: consulta sempre un medico.",
    who_title: "Attività settimanale (OMS)",
    who_vigorous: "Alta intensità",
    who_target_reached: "Target OMS raggiunto!",
    longevity_trend: "Andamento Longevità",
    about_link: "Chi siamo",
    contact_link: "Contatti",
    terms_link: "Termini di Servizio",
    privacy_link: "Privacy Policy",
    consent1_pre: "Ho letto e accetto i ",
    consent1_mid: " e ho preso visione dell'",
    consent1_privacy: "Informativa sulla Privacy",
    consent1_post: ".",
    consent2: "Acconsento al trattamento dei miei dati relativi al benessere e alla salute (alimentazione, attività fisica, sonno, freddo, respirazione, relazioni, diario, e le eventuali patologie e dolori che scelgo di indicare), anche da parte dei professionisti del programma e tramite un servizio di intelligenza artificiale, per generare il mio piano personalizzato. Posso revocare il consenso in qualsiasi momento scrivendo a info@riseyourlife.it.",
    consent_error: "Per registrarti devi accettare entrambe le caselle.",
    legal_back: "Torna alla home",
    // track
    save_day: "Salva la giornata",
    saved: "Giornata salvata!",
    add_activity: "Aggiungi attività",
    from_diary_note: "Alcune voci sono arrivate dal tuo Diario Longevità: ricordati di specificare gli orari.",
    from_diary_tag: "dal Diario",
    journey: "Il Viaggio della Longevità",
    journey_sub: "Il tuo programma dinamico di 12 settimane, personalizzato sui tuoi punti di forza e debolezza.",
    program: "Programma",
    open_program: "Apri il programma",
    generate_program: "Genera il mio programma",
    program_generating: "Sto creando il tuo programma di 12 settimane... (può richiedere 1-2 minuti)",
    program_analysis_phase: "Fase di analisi in corso. Registra i tuoi dati per 7 giorni: il tuo programma personalizzato si sbloccherà l'8° giorno.",
    day_num: "Giorno",
    week: "Settimana",
    view_goals: "Obiettivi settimana",
    view_daily: "Dettaglio giorni",
    completed: "Completato",
    move: "Sposta",
    move_to: "Sposta l'attività a un altro giorno",
    balance_warning_title: "Attenzione all'equilibrio",
    balance_warning_body: "Spostando questa attività il pilastro resta scoperto in questa settimana. Rischi di sbilanciare i 6 pilastri. Vuoi procedere comunque?",
    proceed: "Procedi comunque",
    cancel: "Annulla",
    tasks_done: "completate",
    summary: "Riepilogo",
    summary_title: "Riepilogo 12 Settimane",
    summary_sub: "L'andamento dei 6 pilastri lungo tutto il tuo viaggio.",
    download_pdf: "Scarica PDF",
    progress_by_pillar: "Completamento per pilastro",
    overall_completion: "Completamento totale",
    record: "Detta",
    recording: "Sto ascoltando...",
    transcribing: "Trascrizione...",
    diary_date: "Data",
    today_label: "Oggi",
    med_diet_title: "Dieta Mediterranea",
    med_diet_priority: "Il tuo riferimento n°1",
    med_diet_body: "La qualità e l'equilibrio dei pasti mediterranei sono la base della tua longevità. Punta al Semaforo Verde: verdura, legumi, cereali integrali, olio EVO, pesce, frutta secca.",
    advanced_options: "Opzioni avanzate",
    fasting_title: "Digiuno intermittente",
    fasting_desc: "Opzione avanzata e facoltativa. Attivala solo se lo desideri.",
    fasting_enable: "Attiva",
    fasting_active: "Attivo",
    fasting_disclaimer_title: "Disclaimer medico obbligatorio",
    fasting_disclaimer_body: "Il digiuno intermittente NON è adatto a tutti. È controindicato in gravidanza/allattamento, in caso di diabete (soprattutto insulino-trattato), disturbi alimentari, sottopeso, età avanzata, minori e in presenza di alcune patologie o terapie. Può causare ipoglicemia, affaticamento e altri effetti. Consulta OBBLIGATORIAMENTE il tuo medico prima di iniziare. RISE your LIFE non fornisce consulenza medica.",
    fasting_accept: "Ho letto e accetto, consulterò il mio medico",
    fasting_cancel: "Annulla",
    protocol: "Protocollo",
    eating_start_label: "Inizio finestra alimentare",
    timer_eating: "Finestra alimentare aperta",
    timer_fasting: "In digiuno",
    autophagy_zone: "Zona autofagia",
    time_to_eat: "al prossimo pasto",
    time_to_close: "alla chiusura della finestra",
    hours_fasted: "di digiuno",
    med_reminder: "Ricorda: il digiuno non sostituisce mai una corretta alimentazione mediterranea.",
    bio_title: "Età biologica stimata",
    chrono_age: "Età anagrafica",
    bio_younger: "anni più giovane",
    bio_note: "Stima basata sul tuo stile di vita registrato. Non è un dato medico: migliora completando le attività dei 6 pilastri.",
    bio_add_age: "Aggiungi la tua età nel profilo per stimare l'età biologica.",
    back: "Indietro",
    rise_moment_title: "Il tuo momento Rise",
    rise_inspiration: "Ispirazione",
    rise_science: "Scienza",
    rise_task: "Compito del giorno",
    rise_theme: "Tema",
    book_specialist: "Prenota consulenza specialistica",
    specialist_hint: "Se hai bisogno di una consulenza specifica per il tuo percorso di longevità, i nostri esperti sono a tua disposizione.",
    today_tasks: "I compiti di oggi",
    no_tasks_today: "Nessun compito in programma per oggi. Goditi il recupero!",
    open_full_program: "Vedi tutto il programma",
    journey_home_kicker: "Il tuo Viaggio della Longevità",
    journey_progress: "Avanzamento del viaggio",
    day_of_journey: "Giorno",
    log_another_day: "Registra un altro giorno",
    workout_card: "Scheda allenamento",
    workout_exercise: "Esercizio",
    workout_warmup: "Riscaldamento",
    workout_series: "Serie",
    workout_reps: "Ripetizioni",
    workout_rest: "Recupero",
    workout_duration: "Durata",
    dictate_field: "Detta",
    track_date: "Giorno da registrare",
    share_journey: "Condividi il viaggio",
    share_ready: "Immagine pronta!",
    share_card_title: "Il mio Viaggio della Longevità",
    share_weeks: "settimane",
    share_completion: "completamento",
    share_bio_younger: "anni più giovane",
    reminder_journey_a: "Hai ancora",
    reminder_journey_b: "compiti da completare oggi. Non perdere la tua serie!",
    reminder_analysis: "Non hai ancora registrato la giornata di oggi. Mantieni viva la tua serie!",
    reminder_cta_journey: "Vai ai compiti",
    reminder_cta_analysis: "Registra ora",
    reminder_dismiss: "Chiudi",
    devices: "Dispositivi",
    devices_title: "Collega un dispositivo",
    devices_sub: "Sincronizza sonno e movimento. I wearable arriveranno presto; per ora importa i tuoi dati da file.",
    coming_soon: "Presto disponibile",
    notify_me: "Avvisami",
    notify_saved: "Ti avviseremo appena sarà disponibile!",
    import_title: "Importa dati (CSV)",
    import_hint: "Carica un CSV con le colonne: date, sleep_hours, exercise_minutes, exercise_type, steps. La data in formato AAAA-MM-GG.",
    download_template: "Scarica modello CSV",
    import_now: "Importa i dati",
    import_done: "Dati importati",
    rows_ready: "righe pronte all'import",
    open_devices: "Collega dispositivo",
    weekly_goals_title: "Obiettivi della settimana",
    maxim_of_day: "Massima del giorno",
    maxim_expand: "Apri il Momento Rise",
    maxim_hide: "Chiudi il Momento Rise",
    bio_trend_title: "Andamento Età Biologica",
    goal_today_label: "Cosa fare oggi",
    weekly_program_pdf: "Scarica PDF settimana",
    admin_user_reports: "Report generati per profilo",
    admin_no_reports: "Nessun report generato",
    admin_filter_age_min: "Età min",
    admin_filter_age_max: "Età max",
    admin_filter_pathology: "Patologia / condizione",
    admin_filter_pathology_ph: "es. diabete, ipertensione…",
    admin_filter_apply: "Filtra",
    admin_filter_reset: "Azzera",
    admin_filter_empty: "Nessun profilo corrisponde ai filtri",
    admin_consultations: "Richieste di consulenza",
    admin_consultations_empty: "Nessuna richiesta di consulenza al momento.",
    admin_top_problems: "3 problemi principali del cluster",
    admin_improvement: "Andamento del miglioramento",
    admin_improvement_sub: "{n}/{m} utenti misurati con Età Biologica in calo.",
    admin_clinical_generate: "Genera riassunto clinico AI",
    admin_clinical_loading: "Generazione riassunto clinico...",
    admin_clinical_error: "Errore nella generazione. Riprova.",
    admin_clinical_title: "Riassunto clinico AI",
    admin_clinical_refresh: "Rigenera",
    protocol_stress_detected: "Segnali di stress rilevati",
    protocol_inflammation_detected: "Segnali di infiammazione rilevati",
    protocol_offer: "Vuoi attivare il Protocollo Alimentare Anti-infiammatorio? Adatteremo consigli e analisi del diario secondo i nostri standard medici.",
    protocol_disclaimer: "Il protocollo ha finalità di benessere e non sostituisce il parere medico.",
    protocol_activate: "Attiva il Protocollo Anti-infiammatorio",
    protocol_active: "Protocollo Alimentare Anti-infiammatorio attivo: i tuoi consigli sono ottimizzati per ridurre l'infiammazione.",
    protocol_disable: "Disattiva",
    protocol_activated: "Protocollo attivato",
    protocol_deactivated: "Protocollo disattivato",
    protocol_foods_title: "Cosa mangiare (e cosa evitare)",
    protocol_prefer: "Da preferire",
    protocol_avoid: "Da limitare",
    weeks_in_row: "sett. di fila",
    share_report: "Condividi",
    report_share_kicker: "Il mio report settimanale",
    report_share_line: "giorni di percorso analizzati",
    // admin
    admin_dashboard: "Dashboard Aziendale",
    admin_note: "Solo dati aggregati e anonimi. Mai dati individuali.",
    total_employees: "Dipendenti totali",
    active_users: "Utenti attivi",
    completion_rate: "Tasso di partecipazione",
    completed_week: "Hanno completato la settimana",
    avg_points: "Punti medi",
    reports_generated: "Report generati",
    area_participation: "Partecipazione per area",
    no_reports: "Nessun report ancora. Registra i tuoi dati e genera il primo report.",
    profile_nav: "Profilo",
    protocols_nav: "Protocolli",
    profile_title: "Il mio profilo",
    profile_sub: "Aggiorna i tuoi dati: l'età sblocca la stima dell'Età Biologica e personalizza il tuo programma in sicurezza.",
    profile_save: "Salva profilo",
    profile_saved: "Profilo aggiornato",
    profile_age_alert: "Inserisci la tua età anagrafica: serve a stimare l'Età Biologica e a personalizzare consigli e programma.",
    protocols_title: "Protocolli di sicurezza",
    protocols_sub: "Linee guida prudenti di stile di vita per condizioni comuni. Se dichiari una di queste condizioni nel profilo, vengono integrate automaticamente nel tuo report AI.",
    protocols_disclaimer: "Contenuti di benessere a scopo informativo, non diagnosi né terapia. Consulta sempre un medico o uno specialista prima di iniziare o modificare qualsiasi attività o alimentazione.",
    home_tools: "Strumenti",
    weekly_guide_pdf: "Guida pratica settimanale",
    infographic_pdf: "Scarica PDF",
    report_mode_hint: "Scegli lo stile del report prima di generarlo.",
    report_practical: "Sintesi Pratica",
    report_scientific: "Analisi Bio-Scientifica",
    view_workout: "Vedi scheda",
    go_to_section: "Vai alla sezione",
    rings_title: "La tua giornata",
    rings_today: "Oggi",
    monthly_objective: "Obiettivo del mese",
    how_to_do: "Come si fa",
    register_today: "Registra oggi",
    no_workout_today: "Nessun allenamento previsto oggi. Goditi il recupero.",
    profile_weight: "Peso (kg)",
    profile_height: "Altezza (cm)",
    profile_training_days: "Giorni di allenamento",
    day_mon: "Lun", day_tue: "Mar", day_wed: "Mer", day_thu: "Gio", day_fri: "Ven", day_sat: "Sab", day_sun: "Dom",
    mds_title: "Hai bisogno di una consulenza specifica?",
    mds_sub: "I nostri esperti MDS MED sono a tua disposizione per il tuo percorso di longevità.",
    mds_write_us: "Scrivici qui",
    mds_send: "Invia richiesta",
    mds_sent: "Richiesta inviata! Ti ricontatteremo presto.",
    mds_topic_ph: "Argomento (es. sonno, alimentazione...)",
    mds_message_ph: "Descrivi brevemente di cosa hai bisogno...",
    mds_phone_ph: "Telefono (facoltativo)",
    register_as_done: "Registra come Fatto",
    learn_read_first: "Leggi la spiegazione per continuare...",
    learn_video_soon: "Video dimostrativo in arrivo",
    learn_not_found: "Contenuto non trovato",
    longevity_diary: "Diario della Longevità",
    daily_diary: "Diario Giornaliero",
    today_task: "Il tuo compito di oggi",
    today_task_cta: "Apri la scheda tecnica del giorno",
    rest_timer: "Timer recupero",
    rest_done: "Fatto!",
    breath_coherence: "Coerenza Cardiaca · Respiro 5-5",
    breath_ready: "Pronto?",
    breath_inhale: "Inspira",
    breath_exhale: "Espira",
    breath_start: "Avvia",
    breath_stop: "Ferma",
    breath_cycles: "Cicli",
    tenant_powered_by: "con RISE your LIFE",
    tenant_join_sub: "Crea il tuo account e inizia il tuo percorso di longevità.",
    admin_company: "Azienda",
    admin_add_company: "Aggiungi azienda",
    admin_add_company_desc: "Crea un nuovo spazio aziendale con nome, link dedicato e logo. I dipendenti si registreranno dal link e vedranno il logo dell'azienda.",
    admin_company_name: "Nome azienda",
    admin_company_slug: "Link dedicato (slug)",
    admin_company_logo_url: "Logo (URL)",
    admin_company_logo_or: "oppure carica un file:",
    admin_create_company: "Crea azienda",
    admin_company_created: "Azienda creata con successo!",
    admin_logo_too_big: "Immagine troppo grande (max 400KB). Usa un URL o un file più piccolo.",
    admin_download_pdf: "Scarica PDF",
    admin_edit_company: "Modifica",
    admin_save_company: "Salva modifiche",
    admin_company_updated: "Azienda aggiornata!",
    admin_company_accent: "Colore",
    admin_company_welcome: "Messaggio di benvenuto",
    admin_company_welcome_ph: "Es. Benvenuto nel team!",
    admin_company_active: "Azienda attiva (link di registrazione abilitato)",
    admin_compare_title: "Confronto tra aziende",
    admin_compare_sub: "Partecipazione media e coinvolgimento per azienda (dati aggregati).",
    breath_hold: "Trattieni",
    breath_rhythm: "Ritmo",
    regen_title: "Aggiorna il mio Viaggio",
    regen_desc: "Hai aggiornato i tuoi dati? Ricalcola le settimane future del programma mantenendo i giorni già registrati.",
    regen_button: "Aggiorna il mio Viaggio",
    regen_confirm_title: "Aggiornare il tuo Viaggio?",
    regen_confirm_body: "Le settimane future verranno rigenerate in base ai tuoi nuovi dati (età, peso, dieta, patologie, obiettivi). I giorni già svolti e i loro progressi restano invariati. Vuoi procedere?",
    regen_confirm_yes: "Sì, aggiorna",
    regen_started: "Sto ricalcolando le settimane future del tuo Viaggio...",
    regen_no_program: "Genera prima il tuo Viaggio di 12 settimane.",
    diary_analysis_style: "Stile dell'analisi",
    qr_breath: "Respiro guidato",
    qr_program: "Le tue schede",
    qr_diary: "Diario AI",
    qr_scan_hint: "Inquadra i QR con il telefono per aprire timer e schede nell'app.",
    forgot_password_q: "Password dimenticata?",
    forgot_title: "Recupera password",
    forgot_sub: "Inserisci la tua email: ti invieremo un link per reimpostare la password.",
    forgot_send: "Invia link di reset",
    forgot_sent: "Se l'email è registrata, riceverai a breve un link per reimpostare la password. Controlla anche lo spam.",
    reset_title: "Reimposta password",
    reset_sub: "Scegli una nuova password per il tuo account.",
    reset_new: "Nuova password",
    reset_confirm: "Conferma password",
    reset_submit: "Aggiorna password",
    reset_done: "Password aggiornata! Ora puoi accedere.",
    reset_min: "La password deve avere almeno 8 caratteri.",
    password_hint: "Almeno 8 caratteri.",
    show_password: "Mostra password",
    hide_password: "Nascondi password",
    reset_mismatch: "Le password non coincidono.",
    reset_no_token: "Link non valido. Richiedi un nuovo reset dalla pagina di accesso.",
  },
  en: {
    brand: "RISE your LIFE",
    tagline: "Let's grow. One day at a time.",
    hero_title: "Your wellbeing plan in 7 days.",
    hero_sub: "The longevity program for corporate welfare. Log a week of habits across the 6 wellbeing areas and get personalized feedback guided by industry professionals and AI.",
    cta_start: "Get started",
    aud_personal: "For you",
    aud_business: "For companies",
    hero_sub_personal: "Log your nutrition, movement, sleep and habits for 7 days. Get a personalised plan, built with the programme's professionals and generated with artificial intelligence. Free.",
    hero_title_biz: "Your employees' wellbeing, one day at a time.",
    hero_sub_biz: "A corporate welfare programme across 6 areas: nutrition, physical activity, sleep, cold, breathing and relationships. Every employee receives a personalised plan.",
    cta_free: "Start for free",
    cta_code_link: "Have a company code? Register here",
    cta_book_demo: "Book a presentation",
    how_personal_title: "How it works",
    how_p1: "Sign up and set your goal",
    how_p2: "For 7 days you log your habits, by voice too",
    how_p3: "Receive your personalised plan",
    faq_title: "Privacy at a glance",
    faq_q1: "Can the company see individual employees' data?",
    faq_a1: "No. The company never receives employees' personal data. Any reports for the company will contain only aggregated, anonymous data.",
    faq_q2: "Who sees individual data?",
    faq_a2: "Only the RISE your LIFE programme professionals appointed by the data controller, MDS – MED SRL, to build the personalised plan.",
    faq_q3: "Does RISE your LIFE make diagnoses?",
    faq_a3: "No. It is a wellbeing programme: it provides no diagnosis or treatment and does not replace medical advice.",
    cta_login: "Log in",
    how_title: "How it works at your company",
    step1_t: "Kickoff & goals",
    step1_d: "We present the longevity fundamentals and you set your goal.",
    step2_t: "1 week of data",
    step2_d: "Log sleep, movement, nutrition, cold, breathing and relationships.",
    step3_t: "AI feedback",
    step3_d: "Get a personalized plan based on your data and goals.",
    pillars_title: "The 6 wellbeing areas",
    login: "Log in",
    register: "Sign up",
    email: "Email",
    password: "Password",
    name: "Name",
    first_name: "First name",
    invite_code: "Company code",
    invite_code_hint: "If your company gave you one. Otherwise leave blank.",
    invite_code_invalid: "Invalid code. Check with your company or leave the field blank.",
    invite_code_limit: "Too many attempts, please try again later.",
    admin_invite_code: "Company code",
    admin_below_threshold: "Data available from {n} participants upwards, to protect employee privacy.",
    admin_copy: "Copy",
    admin_copied: "Code copied",
    admin_regenerate: "Regenerate",
    admin_regenerate_confirm: "The old code will stop working.",
    ai_disclaimer: "RISE your LIFE content is for wellness purposes and does not replace medical advice: it provides no diagnosis or treatment.",
    last_name: "Last name",
    admin_slug_reserved: "Reserved address, please choose another one.",
    company: "Company",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    logout: "Log out",
    nutrition: "Nutrition",
    exercise: "Exercise",
    sleep: "Sleep",
    cold: "Cold",
    breathing: "Breathing",
    relationships: "Relationships",
    pillars: "Pillars",
    corollaries: "Corollaries",
    onboard_title: "Set your goal",
    onboard_sub: "Your goal will guide the AI personalized feedback.",
    goal_label: "What is your main goal?",
    focus_label: "Which areas do you want to focus on? (optional)",
    save: "Save and start",
    dashboard: "Dashboard",
    welcome: "Welcome back",
    day_of: "Day",
    track_today: "Log today",
    points: "Points",
    streak: "Day streak",
    badges: "Achievements",
    days_logged: "Days logged",
    weekly_report: "Weekly report",
    generate_report: "Generate AI report",
    generating: "Generating...",
    reports: "My reports",
    wakeup_card: "Relational wellbeing — on wake-up",
    diary: "Diary",
    diary_title: "Longevity Diary",
    diary_sub: "Write naturally what you eat and do. AI analyzes glycemic load, nutrients and recovery.",
    diary_placeholder: "E.g. \"Intense 40-minute run\" or \"Pasta with pesto and an orange\"",
    diary_send: "Analyze",
    analyzing: "Analyzing...",
    diary_empty: "Your diary is empty. Write your first meal or workout above.",
    open_diary: "Open diary",
    longevity_score: "Longevity Score",
    level: "Level",
    to_next: "points to next level",
    max_level: "Max level reached!",
    glycemic_load: "Glycemic load",
    nutrients: "Nutrients",
    vitamins: "Vitamins",
    antioxidants: "Antioxidants",
    macros: "Macronutrients",
    advice: "Advice",
    recovery_meal: "Post-workout recovery",
    injury_prevention: "Injury prevention",
    points_earned: "points",
    intensity: "Intensity",
    duration: "Duration",
    calories: "Est. calories",
    tl_verde: "Green",
    tl_giallo: "Yellow",
    tl_rosso: "Red",
    onboard_sports: "Which sports or activities do you practice?",
    sports_placeholder: "E.g. running, swimming, gym, yoga...",
    onboard_frequency: "How often do you train?",
    freq_none: "Rarely / Never",
    freq_1_2: "1-2 times a week",
    freq_3_4: "3-4 times a week",
    freq_5plus: "5+ times a week",
    onboard_diet: "Dietary preferences",
    diet_completo: "Complete (omnivore)",
    diet_mediterraneo: "Mediterranean",
    diet_vegetariano: "Vegetarian",
    diet_vegano: "Vegan",
    onboard_age: "Age",
    onboard_conditions: "Chronic conditions (optional)",
    conditions_placeholder: "E.g. diabetes, hypertension, thyroid...",
    onboard_pain: "Pain or areas to protect (optional)",
    pain_placeholder: "E.g. right knee, lower back...",
    onboard_health_note: "This information helps personalize advice safely. RISE your LIFE does not provide diagnosis: always consult a doctor.",
    who_title: "Weekly activity (WHO)",
    who_vigorous: "High intensity",
    who_target_reached: "WHO target reached!",
    longevity_trend: "Longevity Trend",
    about_link: "About us",
    contact_link: "Contact",
    terms_link: "Terms of Service",
    privacy_link: "Privacy Policy",
    consent1_pre: "I have read and accept the ",
    consent1_mid: " and have read the ",
    consent1_privacy: "Privacy Policy",
    consent1_post: ".",
    consent2: "I consent to the processing of my wellness and health data (nutrition, physical activity, sleep, cold exposure, breathing, relationships, diary, and any chronic conditions and pain I choose to report), including by the programme's professionals and through an artificial intelligence service, to generate my personalised plan. I can withdraw my consent at any time by writing to info@riseyourlife.it.",
    consent_error: "To register you must accept both boxes.",
    legal_back: "Back to home",
    save_day: "Save the day",
    saved: "Day saved!",
    add_activity: "Add activity",
    from_diary_note: "Some entries came from your Longevity Diary: remember to specify the times.",
    from_diary_tag: "from Diary",
    journey: "The Longevity Journey",
    journey_sub: "Your dynamic 12-week program, personalized on your strengths and weaknesses.",
    program: "Program",
    open_program: "Open the program",
    generate_program: "Generate my program",
    program_generating: "Creating your 12-week program... (may take 1-2 minutes)",
    program_analysis_phase: "Analysis phase in progress. Log your data for 7 days: your personalized program unlocks on day 8.",
    day_num: "Day",
    week: "Week",
    view_goals: "Week goals",
    view_daily: "Daily detail",
    completed: "Completed",
    move: "Move",
    move_to: "Move activity to another day",
    balance_warning_title: "Balance warning",
    balance_warning_body: "Moving this activity leaves this pillar uncovered this week. You risk unbalancing the 6 pillars. Proceed anyway?",
    proceed: "Proceed anyway",
    cancel: "Cancel",
    tasks_done: "completed",
    summary: "Summary",
    summary_title: "12-Week Summary",
    summary_sub: "The trend of the 6 pillars across your whole journey.",
    download_pdf: "Download PDF",
    progress_by_pillar: "Completion by pillar",
    overall_completion: "Overall completion",
    record: "Dictate",
    recording: "Listening...",
    transcribing: "Transcribing...",
    diary_date: "Date",
    today_label: "Today",
    med_diet_title: "Mediterranean Diet",
    med_diet_priority: "Your #1 reference",
    med_diet_body: "The quality and balance of Mediterranean meals is the foundation of your longevity. Aim for the Green Light: vegetables, legumes, whole grains, EVO oil, fish, nuts.",
    advanced_options: "Advanced options",
    fasting_title: "Intermittent fasting",
    fasting_desc: "Advanced, optional feature. Enable it only if you want to.",
    fasting_enable: "Enable",
    fasting_active: "Active",
    fasting_disclaimer_title: "Mandatory medical disclaimer",
    fasting_disclaimer_body: "Intermittent fasting is NOT suitable for everyone. It is contraindicated in pregnancy/breastfeeding, diabetes (especially insulin-treated), eating disorders, underweight, older age, minors, and with certain conditions or therapies. It may cause hypoglycemia, fatigue and other effects. You MUST consult your doctor before starting. RISE your LIFE does not provide medical advice.",
    fasting_accept: "I have read and accept; I will consult my doctor",
    fasting_cancel: "Cancel",
    protocol: "Protocol",
    eating_start_label: "Eating window start",
    timer_eating: "Eating window open",
    timer_fasting: "Fasting",
    autophagy_zone: "Autophagy zone",
    time_to_eat: "to next meal",
    time_to_close: "to window close",
    hours_fasted: "fasted",
    med_reminder: "Remember: fasting never replaces a proper Mediterranean diet.",
    bio_title: "Estimated biological age",
    chrono_age: "Chronological age",
    bio_younger: "years younger",
    bio_note: "Estimate based on your logged lifestyle. Not a medical value: improve it by completing the 6-pillar activities.",
    bio_add_age: "Add your age in your profile to estimate biological age.",
    back: "Back",
    rise_moment_title: "Your Rise moment",
    rise_inspiration: "Inspiration",
    rise_science: "Science",
    rise_task: "Task of the day",
    rise_theme: "Theme",
    book_specialist: "Book a specialist consultation",
    specialist_hint: "If you need specific guidance for your longevity journey, our experts are here for you.",
    today_tasks: "Today's tasks",
    no_tasks_today: "No tasks scheduled for today. Enjoy your recovery!",
    open_full_program: "See full program",
    journey_home_kicker: "Your Longevity Journey",
    journey_progress: "Journey progress",
    day_of_journey: "Day",
    log_another_day: "Log another day",
    workout_card: "Workout card",
    workout_exercise: "Exercise",
    workout_warmup: "Warm-up",
    workout_series: "Sets",
    workout_reps: "Reps",
    workout_rest: "Rest",
    workout_duration: "Duration",
    dictate_field: "Dictate",
    track_date: "Day to log",
    share_journey: "Share journey",
    share_ready: "Image ready!",
    share_card_title: "My Longevity Journey",
    share_weeks: "weeks",
    share_completion: "completion",
    share_bio_younger: "years younger",
    reminder_journey_a: "You still have",
    reminder_journey_b: "tasks to complete today. Don't break your streak!",
    reminder_analysis: "You haven't logged today yet. Keep your streak alive!",
    reminder_cta_journey: "Go to tasks",
    reminder_cta_analysis: "Log now",
    reminder_dismiss: "Dismiss",
    devices: "Devices",
    devices_title: "Connect a device",
    devices_sub: "Sync sleep and movement. Wearables are coming soon; for now import your data from a file.",
    coming_soon: "Coming soon",
    notify_me: "Notify me",
    notify_saved: "We'll notify you as soon as it's available!",
    import_title: "Import data (CSV)",
    import_hint: "Upload a CSV with columns: date, sleep_hours, exercise_minutes, exercise_type, steps. Date in YYYY-MM-DD format.",
    download_template: "Download CSV template",
    import_now: "Import data",
    import_done: "Data imported",
    rows_ready: "rows ready to import",
    open_devices: "Connect device",
    weekly_goals_title: "This week's goals",
    maxim_of_day: "Maxim of the day",
    maxim_expand: "Open your Rise Moment",
    maxim_hide: "Close your Rise Moment",
    bio_trend_title: "Biological Age Trend",
    goal_today_label: "What to do today",
    weekly_program_pdf: "Download week PDF",
    admin_user_reports: "Reports by user profile",
    admin_no_reports: "No report generated",
    admin_filter_age_min: "Min age",
    admin_filter_age_max: "Max age",
    admin_filter_pathology: "Pathology / condition",
    admin_filter_pathology_ph: "e.g. diabetes, hypertension…",
    admin_filter_apply: "Filter",
    admin_filter_reset: "Reset",
    admin_filter_empty: "No profile matches the filters",
    admin_consultations: "Consultation requests",
    admin_consultations_empty: "No consultation requests yet.",
    admin_top_problems: "Cluster's top 3 problems",
    admin_improvement: "Improvement trend",
    admin_improvement_sub: "{n}/{m} measured users with decreasing Biological Age.",
    admin_clinical_generate: "Generate AI clinical summary",
    admin_clinical_loading: "Generating clinical summary...",
    admin_clinical_error: "Generation error. Try again.",
    admin_clinical_title: "AI clinical summary",
    admin_clinical_refresh: "Regenerate",
    protocol_stress_detected: "Stress signals detected",
    protocol_inflammation_detected: "Inflammation signals detected",
    protocol_offer: "Would you like to activate the Anti-inflammatory Food Protocol? We'll tailor advice and diary analysis to our medical standards.",
    protocol_disclaimer: "The protocol is for wellness purposes and does not replace medical advice.",
    protocol_activate: "Activate Anti-inflammatory Protocol",
    protocol_active: "Anti-inflammatory Food Protocol active: your advice is optimized to reduce inflammation.",
    protocol_disable: "Disable",
    protocol_activated: "Protocol activated",
    protocol_deactivated: "Protocol deactivated",
    protocol_foods_title: "What to eat (and avoid)",
    protocol_prefer: "Prefer",
    protocol_avoid: "Limit",
    weeks_in_row: "weeks in a row",
    share_report: "Share",
    report_share_kicker: "My weekly report",
    report_share_line: "days of journey analyzed",
    admin_dashboard: "Corporate Dashboard",
    admin_note: "Aggregated and anonymous data only. Never individual data.",
    total_employees: "Total employees",
    active_users: "Active users",
    completion_rate: "Participation rate",
    completed_week: "Completed the week",
    avg_points: "Average points",
    reports_generated: "Reports generated",
    area_participation: "Participation by area",
    no_reports: "No reports yet. Log your data and generate your first report.",
    profile_nav: "Profile",
    protocols_nav: "Protocols",
    profile_title: "My profile",
    profile_sub: "Update your details: your age unlocks the Biological Age estimate and safely personalizes your program.",
    profile_save: "Save profile",
    profile_saved: "Profile updated",
    profile_age_alert: "Enter your chronological age: it's needed to estimate Biological Age and personalize advice and program.",
    protocols_title: "Safety protocols",
    protocols_sub: "Prudent lifestyle guidelines for common conditions. If you declare one of these in your profile, they are automatically woven into your AI report.",
    protocols_disclaimer: "Wellness content for informational purposes, not diagnosis or therapy. Always consult a doctor or specialist before starting or changing any activity or diet.",
    home_tools: "Tools",
    weekly_guide_pdf: "Practical weekly guide",
    infographic_pdf: "Download PDF",
    report_mode_hint: "Choose the report style before generating it.",
    report_practical: "Practical Summary",
    report_scientific: "Bio-Scientific Analysis",
    view_workout: "View workout",
    go_to_section: "Go to section",
    rings_title: "Your day",
    rings_today: "Today",
    monthly_objective: "Monthly objective",
    how_to_do: "How to do it",
    register_today: "Log today",
    no_workout_today: "No workout planned today. Enjoy the recovery.",
    profile_weight: "Weight (kg)",
    profile_height: "Height (cm)",
    profile_training_days: "Training days",
    day_mon: "Mon", day_tue: "Tue", day_wed: "Wed", day_thu: "Thu", day_fri: "Fri", day_sat: "Sat", day_sun: "Sun",
    mds_title: "Need specific guidance?",
    mds_sub: "Our MDS MED experts are here for your longevity journey.",
    mds_write_us: "Write to us",
    mds_send: "Send request",
    mds_sent: "Request sent! We'll reach out soon.",
    mds_topic_ph: "Topic (e.g. sleep, nutrition...)",
    mds_message_ph: "Briefly describe what you need...",
    mds_phone_ph: "Phone (optional)",
    register_as_done: "Register as Done",
    learn_read_first: "Read the explanation to continue...",
    learn_video_soon: "Demo video coming soon",
    learn_not_found: "Content not found",
    longevity_diary: "Longevity Diary",
    daily_diary: "Daily Diary",
    today_task: "Your task for today",
    today_task_cta: "Open today's technical card",
    rest_timer: "Rest timer",
    rest_done: "Done!",
    breath_coherence: "Cardiac Coherence · 5-5 breathing",
    breath_ready: "Ready?",
    breath_inhale: "Inhale",
    breath_exhale: "Exhale",
    breath_start: "Start",
    breath_stop: "Stop",
    breath_cycles: "Cycles",
    tenant_powered_by: "with RISE your LIFE",
    tenant_join_sub: "Create your account and start your longevity journey.",
    admin_company: "Company",
    admin_add_company: "Add company",
    admin_add_company_desc: "Create a new company space with name, dedicated link and logo. Employees register from the link and see the company logo.",
    admin_company_name: "Company name",
    admin_company_slug: "Dedicated link (slug)",
    admin_company_logo_url: "Logo (URL)",
    admin_company_logo_or: "or upload a file:",
    admin_create_company: "Create company",
    admin_company_created: "Company created successfully!",
    admin_logo_too_big: "Image too large (max 400KB). Use a URL or a smaller file.",
    admin_download_pdf: "Download PDF",
    admin_edit_company: "Edit",
    admin_save_company: "Save changes",
    admin_company_updated: "Company updated!",
    admin_company_accent: "Color",
    admin_company_welcome: "Welcome message",
    admin_company_welcome_ph: "e.g. Welcome to the team!",
    admin_company_active: "Company active (registration link enabled)",
    admin_compare_title: "Company comparison",
    admin_compare_sub: "Average participation and engagement per company (aggregated data).",
    breath_hold: "Hold",
    breath_rhythm: "Rhythm",
    regen_title: "Update my Journey",
    regen_desc: "Updated your data? Recalculate the future weeks of your program while keeping the days you've already logged.",
    regen_button: "Update my Journey",
    regen_confirm_title: "Update your Journey?",
    regen_confirm_body: "Future weeks will be regenerated based on your new data (age, weight, diet, conditions, goals). Days already completed and their progress stay unchanged. Proceed?",
    regen_confirm_yes: "Yes, update",
    regen_started: "Recalculating the future weeks of your Journey...",
    regen_no_program: "Generate your 12-week Journey first.",
    diary_analysis_style: "Analysis style",
    qr_breath: "Guided breathing",
    qr_program: "Your workout cards",
    qr_diary: "AI diary",
    qr_scan_hint: "Scan the QR codes with your phone to open timers and cards in the app.",
    forgot_password_q: "Forgot password?",
    forgot_title: "Recover password",
    forgot_sub: "Enter your email: we'll send you a link to reset your password.",
    forgot_send: "Send reset link",
    forgot_sent: "If the email is registered, you'll receive a reset link shortly. Check your spam too.",
    reset_title: "Reset password",
    reset_sub: "Choose a new password for your account.",
    reset_new: "New password",
    reset_confirm: "Confirm password",
    reset_submit: "Update password",
    reset_done: "Password updated! You can now log in.",
    reset_min: "Password must be at least 8 characters.",
    password_hint: "At least 8 characters.",
    show_password: "Show password",
    hide_password: "Hide password",
    reset_mismatch: "Passwords do not match.",
    reset_no_token: "Invalid link. Request a new reset from the login page.",
  },
};

const LangContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("w4l_lang") || "it");
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLanguage = (l) => {
    localStorage.setItem("w4l_lang", l);
    setLang(l);
  };
  const t = (key) => dict[lang][key] || key;
  return (
    <LangContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
export const AREAS = ["nutrition", "exercise", "sleep", "cold", "breathing", "relationships"];
